import axios from "axios";
import router from "../router";

// Opsi request tambahan untuk interceptor (lihat penanganan 401 di bawah).
declare module "axios" {
    export interface AxiosRequestConfig {
        skipAuthRedirect?: boolean;
    }
}

let redirectingToLogin = false;

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL || "http://localhost:8081/api",
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Request interceptor — inject JWT token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("ns_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor — handle 401 Unauthorized, 403 setup_required, and license blocks
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // skipAuthRedirect: dipakai polling status pembaruan. Saat update
            // berjalan layanan di-restart dan sesi bisa saja ditolak sesaat —
            // mencabut token + redirect di tengah pembaruan membuat operator
            // "logout sendiri" dan kehilangan halaman progres. Biarkan halaman
            // pembaruan sendiri yang menampilkan status; penyingkiran sesi
            // tetap terjadi pada request API lain.
            const skip = error.config?.skipAuthRedirect === true;
            if (!skip) {
                localStorage.removeItem("ns_token");
                localStorage.removeItem("ns_user");
                if (!redirectingToLogin && router.currentRoute.value.name !== "LoginPage") {
                    redirectingToLogin = true;
                    router.push({ name: "LoginPage" }).finally(() => { redirectingToLogin = false; });
                }
            }
        } else if (error.response?.status === 403 && error.response?.data?.setup_required === true) {
            localStorage.setItem("ns_setup_complete", "false");
            router.push({ name: "SetupWizardPage" });
        } else if (error.response?.status === 403 && error.response?.data?.enforcement_level) {
            // License enforcement block — redirect to license blocked page
            const data = error.response.data;
            localStorage.setItem("ns_license_block", JSON.stringify({
                enforcement_level: data.enforcement_level,
                message: data.message,
                renew_url: data.renew_url,
                days_overdue: data.days_overdue,
            }));
            // Hindari redirect loop jika sudah di halaman LicenseBlocked
            if (router.currentRoute.value.name !== "LicenseBlockedPage") {
                router.push({ name: "LicenseBlockedPage" });
            }
        }
        return Promise.reject(error);
    }
);

export default api;
